/** Betriebsart Sammelstelle. Aufbau wie Viehhändler (9002), eigene Id. */
export const SAMMELSTELLE_BETRIEBSART_ID = 9004;

export function isSammelstelleBetriebsart(id: number | string | null | undefined): boolean {
    return Number(id) === SAMMELSTELLE_BETRIEBSART_ID;
}
